import type { ExperienceObject } from "@/types";
import { ExperienceItem } from "./ExperienceItem";

export function ExperienceList({id, title, experienceObject}: {id: string, title: string, experienceObject: ExperienceObject}) {
  return(
    <section id={id}>
      <div className="content-wrapper">
        <h2>{title}</h2>
        {Object.keys(experienceObject).map((k,i,arr)=> {
          if (experienceObject[k]) {
              return(
              <ExperienceItem
              key={i}
              first={(i === 0)? true : false }
              last={(i === arr.length - 1)? true : false}
              expId={k}
              company={experienceObject[k].company}
              startTime={experienceObject[k].startTime}
              endTime={experienceObject[k].endTime}
              tags={experienceObject[k].tags}
            />)
              }
        })}
      </div>
    </section>
  )
}